export const tutorialData = [
  {
    title_brief: "DER Scenarios",
    title_full: "Introduction to DER-CAM Technology Selection",
    desc: "This video provides a quick overview of DER-CAM technology scenarios and optimization. The exercise here focuses on heating technologies, but the methods used can be applied to a variety of DER technology types. The video walks through building your model, submitting for optimization, and exploring results. A good start for any new users to DER-CAM",
    link: "https://www.youtube.com/embed/pyx7-2_Zkpo",
    date: "Sept, 2025"
  },
  {
    title_brief: "Input Customization",
    title_full: "How to Customize Complex Data Inputs in DER-CAM",
    desc: "This video provides additional guidance on customizing complex inputs in DER-CAM. This is particularly useful for international users, who cannot use the U.S. data libraries present in the tool. Other users looking to customize their models may also find this tutorial helpful.",
    link: "https://www.youtube.com/embed/WVcDzWlbsTE",
    date: "Nov, 2025"
  },

];

// Example Video Playlist Data
// export const tutorialData = [
//   {
//     title_brief: "HTML Basics",
//     title_full: "Introduction to HTML5: Structure and Semantics",
//     desc: "Learn the foundation of the web, from tags to document structure.",
//     link: "https://www.youtube.com/embed/qz0aGYrrlhU",
//     date: "Jan 05, 2026"
//   },
//   {
//     title_brief: "CSS Flexbox",
//     title_full: "Mastering Flexbox: Flexible Layouts Made Easy",
//     desc: "Understand how to align items and distribute space within a container.",
//     link: "https://www.youtube.com/embed/fYq5PXgSsbE",
//     date: "Jan 08, 2026"
//   },
//   {
//     title_brief: "CSS Grid",
//     title_full: "Advanced CSS Grid: Building Complex Layouts",
//     desc: "A deep dive into 2D layouts using the powerful CSS Grid system.",
//     link: "https://www.youtube.com/embed/jV8B24wSN5o",
//     date: "Jan 12, 2026"
//   },
//   {
//     title_brief: "JS Variables",
//     title_full: "JavaScript Fundamentals: Let, Const, and Var",
//     desc: "Everything you need to know about scope and variable declaration.",
//     link: "https://www.youtube.com/embed/XgSjoHvy3nc",
//     date: "Jan 15, 2026"
//   },
//   {
//     title_brief: "DOM Manipulation",
//     title_full: "Interacting with the DOM using Vanilla JavaScript",
//     desc: "Learn how to select, modify, and delete HTML elements dynamically.",
//     link: "https://www.youtube.com/embed/0ik6X4DJKCc",
//     date: "Jan 18, 2026"
//   },
//   {
//     title_brief: "Async JS",
//     title_full: "Asynchronous JavaScript: Promises and Async/Await",
//     desc: "Handle API calls and time-delayed functions like a pro.",
//     link: "https://www.youtube.com/embed/ZYb_L166Vk8",
//     date: "Jan 22, 2026"
//   },
//   {
//     title_brief: "React Intro",
//     title_full: "Getting Started with React: Components and Props",
//     desc: "Build your first modern UI using the React library.",
//     link: "https://www.youtube.com/embed/Ke90Tje7VS0",
//     date: "Jan 25, 2026"
//   },
//   {
//     title_brief: "State Management",
//     title_full: "Managing App State with the UseState Hook",
//     desc: "Learn how to keep your UI in sync with your data.",
//     link: "https://www.youtube.com/embed/O6P86uwfdO0",
//     date: "Jan 29, 2026"
//   },
//   {
//     title_brief: "Responsive Design",
//     title_full: "Mobile-First Design and Media Queries",
//     desc: "Ensure your website looks great on every device size.",
//     link: "https://www.youtube.com/embed/srvUrASNj0s",
//     date: "Feb 02, 2026"
//   },
//   {
//     title_brief: "Web Performance",
//     title_full: "Optimizing Web Performance: Speed and Core Vitals",
//     desc: "Techniques to make your websites load and run faster.",
//     link: "https://www.youtube.com/embed/0fONene3OIA",
//     date: "Feb 05, 2026"
//   },
//   {
//     title_brief: "Node.js Basics",
//     title_full: "Server-Side JS: Getting Started with Node.js",
//     desc: "An introduction to building backend applications with JavaScript.",
//     link: "https://www.youtube.com/embed/RLtyhwFtXWc",
//     date: "Feb 08, 2026"
//   },
//   {
//     title_brief: "Express Framework",
//     title_full: "Building REST APIs with Express.js",
//     desc: "Learn how to route requests and handle middleware in Express.",
//     link: "https://www.youtube.com/embed/SccSCuHhOw0",
//     date: "Feb 12, 2026"
//   },
//   {
//     title_brief: "MongoDB Intro",
//     title_full: "NoSQL Databases: Working with MongoDB",
//     desc: "Understand document-based storage and basic CRUD operations.",
//     link: "https://www.youtube.com/embed/WZm-nE0C6Yg",
//     date: "Feb 15, 2026"
//   },
//   {
//     title_brief: "TypeScript Guide",
//     title_full: "TypeScript for Beginners: Static Typing in JS",
//     desc: "Write safer, cleaner code by implementing types in your workflow.",
//     link: "https://www.youtube.com/embed/BwuLxPH8AVM",
//     date: "Feb 19, 2026"
//   },
//   {
//     title_brief: "Git & GitHub",
//     title_full: "Version Control: Mastering Git and Collaboration",
//     desc: "Learn branching, merging, and pull requests for team projects.",
//     link: "https://www.youtube.com/embed/RGOj5yH7evk",
//     date: "Feb 22, 2026"
//   }
// ];